import { act, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../store/Hooks";
import { setLanguage } from "../../store/SiteSlice";
import { enmDirection } from "../../models/enums/Direction";
import { HtmlHelper } from "../../utils/HtmlHelper";
import { mdlLanguage } from "../../models/ui-models/Language";
import { languages } from "../../consts/Languages";
import { UserService } from "../../services/UserService";

export type LanguageDropdownProps = {
  showText?: boolean;
  onChange?: Function;
  direction?: enmDirection;
}

export const LanguageDropdown = (props: LanguageDropdownProps) => {
  const { t, i18n } = useTranslation();
  const siteStore = useAppSelector((store) => store.site);
  const dispatch = useAppDispatch();
  const random = Math.floor(Math.random() * 11);
  const selector = `language-dropdown-${random}`;

  const [icon, setIcon] = useState<string>();
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedLanguage, setSelectedLanguage] = useState<mdlLanguage>();
  const [activeLanguage, setActiveLanguage] = useState<mdlLanguage>();

  useEffect(() => {
    if (siteStore.language && siteStore.language != selectedLanguage?.value) {
      var languageItem = _.find(languages, function (language) {
        return language.value == siteStore.language;
      });
      if (languageItem != null) {
        if (props.onChange) {
          if (!activeLanguage) {
            setActiveLanguage(languageItem);
            props.onChange(languageItem);
          }
        } else {
          setSelectedLanguage(languageItem);
          setActiveLanguage(languageItem);
        }
      }
    }
    return HtmlHelper.clickOutside(selector, open, setOpen);
  }, [siteStore.language, open]);

  const changeLanguage = async (language: mdlLanguage) => {
    setOpen(false);
    if (props.onChange != undefined) {
      if (selectedLanguage != language) { }
      props.onChange(language);
      setSelectedLanguage(language);
      setActiveLanguage(language);
      return;
    }
    setLoading(true);

    if (siteStore.token) {
      const response = await UserService.UserSetLanguage({ selectedLanguage: language.value });
      if (response.header?.success && response.body?.isSuccessful) {
        toast.success(t("common.success"));
      }
    }
    setLoading(false);
    dispatch(setLanguage(language.value));
  };

  const getDirection = () => {
    if (!props.direction)
      return "open-up";
    switch (props.direction) {
      case enmDirection.DOWN: return "open-down";
      case enmDirection.LEFT: return "open-left";
      case enmDirection.RIGHT: return "open-right";
      default: return "open-up";
    }
  };

  return (
    <li className={`dropdown language-dropdown-${random} d-none d-sm-block me-n1`}>
      <a
        id={selector}
        className={`dropdown-toggle nk-quick-nav-icon ${open ? "show" : ""}`}
        onClick={() => !loading && setOpen(!open)}
      >
        <div className="quick-icon border border-light">
          {loading
            ? <span className="spinner-border spinner-border-sm" />
            : <img className="icon" src={activeLanguage?.icon} />
          }
        </div>
        {
          activeLanguage && activeLanguage.label && props.showText && props.showText == true &&
          <span style={{ fontSize: 15, marginLeft: 10 }}>{t(activeLanguage.label)}</span>
        }
      </a>
      <div
        className={`dropdown-menu dropdown-menu-end dropdown-menu-s1 language-drop ${open ? "show" : ""
          }
        ${getDirection()}
        `}
      >
        <ul className="language-list">
          {languages.map((language: mdlLanguage, index: number) => (
            <li key={index}>
              <a
                onClick={() => changeLanguage(language)}
                className="language-item"
              >
                <img src={language.icon} className="language-flag" />
                <span className="language-name">{t(language.label!)}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};
